import InvitationVue from '@/views/sm/invitation/invitation.vue';

const basePath = '/sm/invitation';
const role = 'sm'; // 角色身份

export const SM_INVITATION_INDEX = 'sm-invitation-index';
export const SM_INVITATION_PREVIEW = 'sm-invitation-preview';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: InvitationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_INVITATION_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/index.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/preview`,
      name: SM_INVITATION_PREVIEW,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/preview.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
